// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: true,
  localvsp: false,
  
  apis: {
    thirdParty: "https://maxis-dealers-api.musea2.azure.ext.gm.com/api",
    //thirdParty: "/api",
    //thirdPartyFull: "https://maxis-dealers.vsp.pp.gm.com/api",
    clickStream: "https://maxis-api-kafkaproducer.apps.pcfepgstg1mi.gm.com/api/clickstream"
  },

  oauthSettingsVSP: {
    authority: 'https://login.microsoftonline.com',
    client_id: '7ed0e645-e6c3-4ab6-9cef-7014d42625a4',
    redirect_uri: 'https://maxis-dealers.musea2.azure.ext.gm.com/',
    post_logout_redirect_uri: 'https://maxis-dealers.musea2.azure.ext.gm.com/',
    response_type: 'code',
    scope: 'openid profile email',
    silent_redirect_uri: 'https://maxis-dealers.musea2.azure.ext.gm.com/silent-renew.html',
    automaticSilentRenew: true,
    filterProtocolClaims: true,
    disablePKCE: true,
    loadUserInfo: false,
    metadata: {
      issuer: "https://login.microsoftonline.com/5de110f8-2e0f-4d45-891d-bcf2218e253d/v2.0",
      authorization_endpoint: "https://login.microsoftonline.com/5de110f8-2e0f-4d45-891d-bcf2218e253d/oauth2/v2.0/authorize",
      jwks_uri: "https://login.microsoftonline.com/5de110f8-2e0f-4d45-891d-bcf2218e253d/discovery/v2.0/keys",
      token_endpoint:"https://login.microsoftonline.com/5de110f8-2e0f-4d45-891d-bcf2218e253d/oauth2/v2.0/token"
    },
    signingKeys: [{"kty":"RSA","e":"AQAB","use":"sig","kid":"key-1","alg":"RS256","value":"-----BEGIN PUBLIC KEY-----\nMIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEA0aBP8VQWD2dGSstqIeg6\n0bmm3SF8yRfR8/O9csENXheo4pRMGLkEjOZITYyDVu9hBq+e1mw98Xv0+mR4clig\nnJFv5M9GtOGGaMhZA47wrSjaztlX+yTQaIFyJpp1DoZR8fbPc0shhHSOQi+DsIWt\nszhK5i3QnzLO0v7tofSeklZLl9BjrUBsKPE+BEZUe4ZNCfBu6QJnSV2H1ViOWWlq\n15ugCD+U35yukHazkiGqG20kyRHqSQvbBGf7gbfYZ6uSkrpscRaSltGX+lWGdoUT\nTfqWmIbHFWSDpZuamU9Wr2SgX0YpAzsNZ/9y+JgRrug32pmE8XNySnCRxT8VRjo5\nJwIDAQAB\n-----END PUBLIC KEY-----","n":"ANGgT_FUFg9nRkrLaiHoOtG5pt0hfMkX0fPzvXLBDV4XqOKUTBi5BIzmSE2Mg1bvYQavntZsPfF79PpkeHJYoJyRb-TPRrThhmjIWQOO8K0o2s7ZV_sk0GiBciaadQ6GUfH2z3NLIYR0jkIvg7CFrbM4SuYt0J8yztL-7aH0npJWS5fQY61AbCjxPgRGVHuGTQnwbukCZ0ldh9VYjllpateboAg_lN-crpB2s5IhqhttJMkR6kkL2wRn-4G32GerkpK6bHEWkpbRl_pVhnaFE036lpiGxxVkg6WbmplPVq9koF9GKQM7DWf_cviYEa7oN9qZhPFzckpwkcU_FUY6OSc"}]
  },

  oauthSettingsGAME: {
    authority: 'https://login.microsoftonline.com',
    client_id: 'dc587413-2b68-4771-837f-7e4ae978b1ca',
    redirect_uri: 'https://maxis-dealers.musea2.azure.ext.gm.com/',
    post_logout_redirect_uri: 'https://maxis-dealers.musea2.azure.ext.gm.com/',
    response_type: 'code',
    scope: 'openid profile email',
    silent_redirect_uri: 'https://maxis-dealers.musea2.azure.ext.gm.com/silent-renew.html',
    automaticSilentRenew: true,
    filterProtocolClaims: true,
    disablePKCE: true,
    loadUserInfo: false,
    metadata: {
      issuer: "https://login.microsoftonline.com/5de110f8-2e0f-4d45-891d-bcf2218e253d/v2.0",
      authorization_endpoint: "https://login.microsoftonline.com/5de110f8-2e0f-4d45-891d-bcf2218e253d/oauth2/v2.0/authorize",
      jwks_uri: "https://login.microsoftonline.com/5de110f8-2e0f-4d45-891d-bcf2218e253d/discovery/v2.0/keys",
      token_endpoint:"https://login.microsoftonline.com/5de110f8-2e0f-4d45-891d-bcf2218e253d/oauth2/v2.0/token"
    },
    signingKeys: [{"kty":"RSA","e":"AQAB","use":"sig","kid":"key-1","alg":"RS256","value":"-----BEGIN PUBLIC KEY-----\nMIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEA0aBP8VQWD2dGSstqIeg6\n0bmm3SF8yRfR8/O9csENXheo4pRMGLkEjOZITYyDVu9hBq+e1mw98Xv0+mR4clig\nnJFv5M9GtOGGaMhZA47wrSjaztlX+yTQaIFyJpp1DoZR8fbPc0shhHSOQi+DsIWt\nszhK5i3QnzLO0v7tofSeklZLl9BjrUBsKPE+BEZUe4ZNCfBu6QJnSV2H1ViOWWlq\n15ugCD+U35yukHazkiGqG20kyRHqSQvbBGf7gbfYZ6uSkrpscRaSltGX+lWGdoUT\nTfqWmIbHFWSDpZuamU9Wr2SgX0YpAzsNZ/9y+JgRrug32pmE8XNySnCRxT8VRjo5\nJwIDAQAB\n-----END PUBLIC KEY-----","n":"ANGgT_FUFg9nRkrLaiHoOtG5pt0hfMkX0fPzvXLBDV4XqOKUTBi5BIzmSE2Mg1bvYQavntZsPfF79PpkeHJYoJyRb-TPRrThhmjIWQOO8K0o2s7ZV_sk0GiBciaadQ6GUfH2z3NLIYR0jkIvg7CFrbM4SuYt0J8yztL-7aH0npJWS5fQY61AbCjxPgRGVHuGTQnwbukCZ0ldh9VYjllpateboAg_lN-crpB2s5IhqhttJMkR6kkL2wRn-4G32GerkpK6bHEWkpbRl_pVhnaFE036lpiGxxVkg6WbmplPVq9koF9GKQM7DWf_cviYEa7oN9qZhPFzckpwkcU_FUY6OSc"}]
  },

  tonicSettings: {
    url: 'https://maxis-api-tonic.oc1i.gm.com',
    // url: 'https://maxis-api-tonic.cpi.gm.com'
  },
}

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
import 'zone.js/dist/zone-error';  // Included with Angular CLI.